import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, PLATFORM_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import {  HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ApmErrorHandler } from '@elastic/apm-rum-angular';
import { init as initApm, ApmBase } from '@elastic/apm-rum';
import { API_BASE_URL } from './services/client.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { TranslateLoader, USE_DEFAULT_LANG } from '@ngx-translate/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './interceptors/auth.interceptor';

export function createApmInstance(): ApmBase {
  return initApm({
    serviceName: 'ECN-Angular-App',
    serverUrl: 'https://a0954be4997144dc9d206d97cdb0e974.apm.westeurope.azure.elastic-cloud.com:443',
    logLevel: 'debug',
    transactionSampleRate: 1.0,
    environment: 'ecn-angular-local-dev',
  });
}

export function initializeApm(apm: ApmBase) {
  return () =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(apm);
      }, 100);
    });
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    { provide: USE_DEFAULT_LANG, useValue: true },
    {
      provide: 'APM_BASE',
      useFactory: createApmInstance,
    },
    { provide: ApmBase, useFactory: createApmInstance },

    {
      provide: APP_INITIALIZER,
      useFactory: initializeApm,
      deps: ['APM_BASE'],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
      deps: [ApmBase],
    },
    {
      provide: API_BASE_URL,
      useFactory: (platformId: object) =>
        isPlatformBrowser(platformId) ? environment.apiBaseUrl : 'https://localhost:44320',
      deps: [PLATFORM_ID],
    },
    {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient],
    }
  ],
};
